<template>
  <div id="hsformdiv" v-once>
  </div>
</template>

<script>
export default {
  props: ['portalId', 'formId'],
  mounted() {
    let node = document.createElement('script');
    node.setAttribute('src', '//js.hsforms.net/forms/shell.js');
    node.onload = () => {
      window.hbspt.forms.create({
        portalId: this.portalId,
        formId: this.formId,
        target: "#hsformdiv"
      });
    };
    document.body.appendChild(node);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/homepage/shared/HubspotForm.vue